import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

import type { ListingRow, ProviderRow, PublicProviderFeedback } from "./public-content.types";

export const getPublicListings = createServerFn({ method: "GET" }).handler(async () => {
  try {
    const { fetchPublicListings } = await import("./supabase.server");
    return { listings: await fetchPublicListings() };
  } catch (error) {
    console.error("Inserate konnten nicht geladen werden", error);
    return { listings: [] as ListingRow[] };
  }
});

export const getPublicProviders = createServerFn({ method: "GET" })
  .validator((data: unknown) =>
    z.object({ type: z.enum(["auftragnehmer", "immobilienmakler"]) }).parse(data),
  )
  .handler(async ({ data }) => {
    try {
      const { fetchPublicProviders } = await import("./supabase.server");
      return { providers: await fetchPublicProviders(data.type), unavailable: false };
    } catch (error) {
      console.error("Anbieter konnten nicht geladen werden", error);
      return { providers: [] as ProviderRow[], unavailable: true };
    }
  });

export const getPublicProviderFeedback = createServerFn({ method: "GET" }).handler(async () => {
  try {
    const { fetchPublicProviderFeedback } = await import("./supabase.server");
    return { feedback: await fetchPublicProviderFeedback() };
  } catch (error) {
    console.error("Auftragnehmerfeedback konnte nicht geladen werden", error);
    return { feedback: [] as PublicProviderFeedback[] };
  }
});
